import { JSX, useCallback } from "react";

import { createStyles, sizes } from "../theme";
import { Checkbox } from "./checkbox";
import { TextBody } from "./text";
import { Pressable } from "react-native";

type Props<N extends string> = {
  label: string | JSX.Element;
  name: N;
  value: boolean;
  onChange: (name: N, value: boolean) => void;
};

export function CheckboxInput<N extends string>({
  label,
  name,
  onChange,
  value,
}: Props<N>) {
  // Handlers
  const handlePress = useCallback(() => {
    onChange(name, !value);
  }, [name, onChange, value]);

  // Render
  return (
    <Pressable onPress={handlePress} style={$.container}>
      <Checkbox checked={value} />
      {typeof label === "string" ? <TextBody>{label}</TextBody> : label}
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    row: 4,
    gap: sizes["1"],
  },
});
